import { connect, ConnectedProps } from 'react-redux'
import CustomError from '../../../../../../../baseComponents/CustomError'
import { ModalLittle } from '../../../../../../../baseComponents/Modal'
import { LittleModalCreateEditChildrenFirst } from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import { checkIfCanCreateQuote } from '../../../../../../../utils/globals/order/order'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { WorkingCenterPayload } from '../../../../../../../utils/reducers/company/workingCenters'
import { getSelectedWorkingCenter, getUserPermissions } from '../../../../../../../utils/reducers/getters'
import { SupplierPayload } from '../../../../../../../utils/reducers/products/suppliers'
import useCreateBuy from '../../../../../../../utils/hooks/buys/orders/useCreateBuy'
import { CustomerPayload } from '../../../../../../../utils/reducers/customers/customer'
import { BillingGroupPayload } from '../../../../../../../utils/reducers/company/billingGroups'
import SearchbarBuySupplierDecider from '../../../../../../../specificComponents/buys/SearchBuySupplierDecider'
import locations from '../../../../../../../utils/globals/locations'
import { BuyModelTypeExtended } from '../../../../../../../specificComponents/buys/SearchBuySupplierDecider/types'

interface ModalCreateBuyDeliveryNoteProps extends ModalEditComponentProps {}

const ModalCreateBuyDeliveryNote: React.FC<ModalCreateBuyDeliveryNoteProps> = ({ setOpened, ...rest }) => {
    const { t } = useTwinTranslation()
    const userPermissionsSupplier = getUserPermissions('supplier.main')
    if (!permissionCheck(userPermissionsSupplier, 'read')) {
        return <ModalLittle opened={true} setOpened={setOpened}>
            <h2 className='mb-25'>
                <TwinTrans transKey='newBuyDeliveryNote'>Nuevo albarán</TwinTrans>
            </h2>
            <CustomError textError={t('noPermissionsToSeeSuppliers', 'No tienes permisos para ver los proveedores')} />
        </ModalLittle>
    }
    return (
        <ModalCreateBuyDeliveryNoteConnect setOpened={setOpened} {...rest} />
    )
}

type ModalCreateBuyDeliveryNoteAfterPermissionsProps = ModalEditComponentProps & ReduxModalCreateBuyDeliveryNoteConnector & {}

const ModalCreateBuyDeliveryNoteAfterPermissions: React.FC<ModalCreateBuyDeliveryNoteAfterPermissionsProps> = ({ userPermissions, allRowData, workingCenters, suppliers, customers, billingGroups,  ...rest }) => {
    const { t } = useTwinTranslation()
    const workingCenter = getSelectedWorkingCenter()
    const { supplierInfo, customerInfo, createBuy, addressFields, mySupplierInfo, extraBillingTypesBuy, parseBTOBeforeSubmit, fileInfo } = useCreateBuy({ suppliers, customers, BillingGroupId: workingCenter?.BillingGroupId, baseURL: locations.buyDeliveryNoteSingle })
    const error = checkIfCanCreateQuote(t, workingCenters?.[workingCenter?.id])
    const fields: FormRender<BuyModelTypeExtended> = [
        {
            cols: 1,
            elements: [
                ...supplierInfo,
                ...mySupplierInfo,
                ...extraBillingTypesBuy,
                {
                    name: 'custom_name',
                    label: t('customName', 'Nombre personalizado'),
                    component: 'InputWithLabelMargin',
                },
                {
                    name: 'OrderId',
                    component: 'Custom',
                    render: () => <SearchbarBuySupplierDecider baseURL={locations.buyDeliveryNoteSingle} getDataURL={'/api/app/order/buy/buyDeliveryNote/getAllBuyDeliveryNotesComplete'} translations={{ title: t('buyDeliveryNote', 'Albarán de compra'), seeText: t('seeBuyDeliveryNote', 'Ver albarán de compra'), duplicateText: t('duplicateBuyDeliveryNoteDots', 'Duplicar albarán...') }} />
                },
                ...customerInfo,
                ...fileInfo,
                {
                    name: 'CurrencyId',
                    component: 'InputHidden',
                    value: workingCenter?.CurrencyId
                },
                {
                    name: 'BillingWorkingCenterId',
                    component: 'InputHidden',
                    value: workingCenter?.id
                },
                {
                    name: 'WorkingCenterId',
                    component: 'InputHidden',
                    value: workingCenter?.id
                }
            ]
        },
        ...addressFields,
        {
            cols:1, 
            elements: [
            ],
        },
    ]
    return (
        <LittleModalCreateEditChildrenFirst fields={error ? [] : fields} url={'/api/app/order/buy/buyDeliveryNote/createBuyDeliveryNote'} imagePath={['tmp']} translations={{
            title: t('newBuyDeliveryNote', 'Nuevo albarán de compra'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={!error}  {...{ ...rest, onSubmit: createBuy }} beforeSubmit={parseBTOBeforeSubmit}>
            {error ? <CustomError textError={error} className='mb-10' /> : null}
            {!workingCenters?.[workingCenter?.id]?.dictCounters && !error ? <CustomError className='mb-10'  textError={t('notFoundWorkingCenterCounterAndForceCreate', 'No se han encontrado contadores disponibles. Si decide continuar, se generará uno automáticamente.')} /> : null}
        </LittleModalCreateEditChildrenFirst>)
}

const modalCreateBuyDeliveryNoteDispatch = {
    setWorkingCenters: (payload: WorkingCenterPayload) => ({ type: 'CHANGE_WORKINGCENTER', payload }),
    setSuppliers: (payload: SupplierPayload) => ({ type: 'CHANGE_SUPPLIER', payload }),
    setCustomers: (payload: CustomerPayload) => ({ type: 'CHANGE_CUSTOMER', payload }),
    setBillingGroups: (payload: BillingGroupPayload) => ({ type: 'CHANGE_BILLINGGROUP', payload }),
}
const mapModalCreateBuyDeliveryNoteConnector = (state: AllReduxPayloads) => ({ workingCenters: state.workingCenters, suppliers: state.suppliers, customers: state.customers, billingGroups: state.billingGroups })
const modalCreateBuyDeliveryNoteConnector = connect(mapModalCreateBuyDeliveryNoteConnector, modalCreateBuyDeliveryNoteDispatch)
type ReduxModalCreateBuyDeliveryNoteConnector = ConnectedProps<typeof modalCreateBuyDeliveryNoteConnector>
const modalCreateBuyDeliveryNoteConnectLoading = withLoading(ModalCreateBuyDeliveryNoteAfterPermissions, [{ fetchUrl: '/api/app/supplier/getAllSuppliers', propName: 'suppliers', setFunctionName: 'setSuppliers' }, { fetchUrl: '/api/app/customer/getAllCustomers', propName: 'customers', setFunctionName: 'setCustomers' }, { fetchUrl: '/api/app/workingCenter/getAllWorkingCentersComplete', propName: 'workingCenters', setFunctionName: 'setWorkingCenters' }, { fetchUrl: '/api/app/config/billingGroup/getAllBillingGroupsComplete', propName: 'billingGroups', setFunctionName: 'setBillingGroups'}])
const ModalCreateBuyDeliveryNoteConnect = modalCreateBuyDeliveryNoteConnector(modalCreateBuyDeliveryNoteConnectLoading)


export default ModalCreateBuyDeliveryNote